/*
  HX SEARCH FILTERS — XCloud bar relocation for the search results page.

  The HEWI search page is XCloud's app-proxy page (/a/search). Its markup is a
  copy of the PLP layout that does NOT carry the theme section's inline script,
  so the relocation cannot live in sections/search__main.liquid for that page.
  Delivering it from this global asset (loaded by layout/theme.liquid) guarantees
  it runs on /a/search.

  XCloud renders its whole bar (#cloud_search_filters_root — filters + its own
  sort) at the top of <main>, above the heading. We move that bar into the
  theme's sticky controls row (#hxControls, below the heading) so it lines up
  with the collection PLP: pills on the left, XCloud's sort on the right. The
  theme's own (empty) filter rail + sort are hidden via body.hx-xcloud-search
  (see hx-objects.css).

  Scoped strictly to the search page — collections do their own XCloud
  relocation in idx-plp and must keep the theme's native sort.
*/
(function () {
  if ((location.pathname || '').indexOf('/search') === -1) return;

  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  ready(function () {
    var controls = document.getElementById('hxControls');
    if (!controls) return;

    function place() {
      var root = document.getElementById('cloud_search_filters_root');
      // Wait until XCloud has actually rendered its pills, not just the empty root.
      if (!root || !root.querySelector('.cloud-search-filter')) return false;
      if (root.parentElement !== controls) controls.appendChild(root);
      document.body.classList.add('hx-xcloud-on');
      document.body.classList.add('hx-xcloud-search');
      return true;
    }

    var raf = null;
    function schedule() {
      if (raf) return;
      raf = window.requestAnimationFrame(function () { raf = null; place(); });
    }

    place();
    // XCloud is a SPA here: it injects the empty root first and fills the pills
    // later (a subtree change), and re-renders the bar on filter/sort clicks.
    // Watch the full subtree and keep relocating — place() is idempotent once
    // the bar already lives in the controls row.
    var main = document.getElementById('root') || document.body;
    var mo = new MutationObserver(schedule);
    mo.observe(main, { childList: true, subtree: true });
  });
})();
